import React from 'react';
import Container from '@material-ui/core/Container';

function HelpPage() {
  return (
    <Container>
      <h1>Ajuda</h1>
    </Container>
  );
}

export default HelpPage;
